import { Modal } from './Modal';

interface ConfirmDialogProps {
  title: string;
  message: string;
  detail?: string;
  confirmLabel?: string;
  tone?: 'danger' | 'normal';
  busy?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

/** Rückfrage vor allem, was sich nicht ohne Weiteres rückgängig machen lässt. */
export function ConfirmDialog({
  title,
  message,
  detail,
  confirmLabel = 'Bestätigen',
  tone = 'danger',
  busy = false,
  onConfirm,
  onCancel,
}: ConfirmDialogProps) {
  return (
    <Modal
      title={title}
      onClose={onCancel}
      width="schmal"
      footer={
        <>
          <button type="button" className="btn" onClick={onCancel} disabled={busy}>
            Abbrechen
          </button>
          <button
            type="button"
            className={tone === 'danger' ? 'btn btn-danger' : 'btn btn-primary'}
            onClick={onConfirm}
            disabled={busy}
          >
            {busy ? 'Bitte warten …' : confirmLabel}
          </button>
        </>
      }
    >
      <div className="stack">
        <p>{message}</p>
        {detail ? <p className="hint">{detail}</p> : null}
      </div>
    </Modal>
  );
}
